import(/* webpackMode: "eager", webpackExports: ["RegisterForm"] */ "/vercel/path0/app/(founder)/auth/register/_components/register-form.tsx");
